import { render, staticRenderFns } from "./otherTranslateSwiper.vue?vue&type=template&id=224a5300"
import script from "./otherTranslateSwiper.vue?vue&type=script&lang=js"
export * from "./otherTranslateSwiper.vue?vue&type=script&lang=js"
import style0 from "./otherTranslateSwiper.vue?vue&type=style&index=0&id=224a5300&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports